import { render, staticRenderFns } from "./CustomQuestionWidget.vue?vue&type=template&id=1ae038de&scoped=true"
import script from "./CustomQuestionWidget.vue?vue&type=script&lang=js"
export * from "./CustomQuestionWidget.vue?vue&type=script&lang=js"
import style0 from "./CustomQuestionWidget.vue?vue&type=style&index=0&id=1ae038de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae038de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSwitch,VTextField,VTooltip})
